import { UseQueryOptions } from "@tanstack/react-query";
import { useGeneralQueryWithToken } from "../useGeneralQuery";
import { AxiosResponse } from "axios";

export interface UserInfoInterface {
	id?: number;
	nickName?: string;
	fio?: string;
	pinfl?: string;
	authTypeId?: number;
	ns10?: number;
	ns11?: number;
	phone?: string;
	cardId?: number;
	resident?: number;
	activityType?: number;
	tin?: string;
}

export const useGetCurrentUser = (params?: object, options: UseQueryOptions<AxiosResponse<any>, Error> = {}) =>
	useGeneralQueryWithToken<UserInfoInterface>("/auth/get-current-user", params, options);
